import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: 'Waterlow Score',
  },
  timeWindow: 7 * 12,
  childProps: {
    yAllowDecimals: false,
    title: chartTitles.waterlow,
    type: 'waterlow',
    yAxisLabel: 'Waterlow Score',
  },
})
